import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';

export class PersonTrainingBus extends BaseBus
{
  CID(): any {
      return this.personTrainingId;
  }
    constructor(data: PersonTrainingBus = null) {
        super(data);
    }
    personTrainingId: any;
    insertUserId: any;
    insertDt: Date;
    updateUserId: any;
    updateDt: Date;
    note: string;
    attachmentDetailFullName: string;
    trainingCategoryId: any;
    personId: any;
}
